/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React, { useCallback } from "react";
import { Button } from "../../../ui/button";
import { Icon } from "../../../Shared/Icon";
import CustomDataGrid from "../../../Shared/Table/CustomDataGrid";
import { migrationColumn } from "../../../Shared/Table/Columns";
import { IMigration } from "../../../../store/api/migration/types";
import { DIALOGOPENFOR } from "../../../../globals/globals";
import { setBasicDialogOpenFor } from "../../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../../store/hooks";
import { useSelector } from "react-redux";
import { searchKeywordSelector } from "../../../../store/search/selector";
import { resetKeyword } from "../../../../store/search/reducer";
import MigrationFilter from "../MigrationFilter";
import { GridSortModel, GridToolbarContainer } from "@mui/x-data-grid";
import { getSortBy } from "../../../../utils/helpers";
import { useMigrationFilter } from "./hooks";
import { resetDeviceFilters } from "../../../../store/filters/Nodes/reducer";
import ActiveFilterChips from "../../../Shared/Filter/ActiveFilterChips";
interface IMigrationProps {
    migrationData: IMigration[],
    isLoading: boolean,
    noOfRows: number,
    setSortOrderToMigration: (value: React.SetStateAction<string>) => void;
}
const Migration: React.FC<IMigrationProps> = ({ migrationData = [], isLoading = false, noOfRows, setSortOrderToMigration }) => {
    const dispatch = useStoreDispatch();
    const { filters: migrationFilters } = useMigrationFilter();
    const searchKeyword = useSelector(searchKeywordSelector);

    const handleClearSearch = useCallback(() => {
        dispatch(resetKeyword());
    }, [dispatch]);

    const handleClearAllFilters = useCallback(() => {
        dispatch(resetDeviceFilters());
        dispatch(resetKeyword());
    }, [dispatch]);

    const newMigrationHandler = () => {
        dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.MIGRATION));
    }

    return (
        <div className="flex flex-col gap-4 w-full">
            <div className="flex items-start justify-between gap-4 w-full">
                <div className="flex-1 max-w-full">
                    <MigrationFilter />
                </div> 
                <Button className="h-10 shrink-0 px-4 text-sm font-medium border border-input bg-background shadow-sm flex items-center gap-2 hover:bg-muted hover:text-accent-foreground transition-colors" variant="outline" onClick={newMigrationHandler}>
                    <Icon name="add" size={18} />
                    New Migration
                </Button>
            </div>
             <div className="flex justify-between items-end mb-0 mt-4">
                <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm text-muted-foreground">{`Showing ${migrationData?.length || 0} results`}</span>
                    <ActiveFilterChips
                        filters={migrationFilters}
                        searchKeyword={searchKeyword}
                        onClearSearch={handleClearSearch}
                        onClearAll={handleClearAllFilters}
                        dispatch={dispatch}
                    />
                </div>

            </div>
            <div className="w-full -mt-3">
                <CustomDataGrid
                    tableId="migration"
                    rows={migrationData}
                    columns={migrationColumn}
                    rowCount={noOfRows}
                    loading={isLoading}
                    disableColumnMenu={true}
                    disableRowSelectionOnClick={true}
                    getRowId={(row: IMigration) => row.serialNumber}
                    paginationMode="server"
                    sortingMode="server"
                    fillContainer
                    onSortModelChange={(params: GridSortModel) => setSortOrderToMigration(getSortBy(params))}
                />
            </div>
        </div>
    )
}
export default Migration;